import React, { useEffect, useState } from 'react';
import { Star, Loader2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { apiError, getResearch, postResearch, RESEARCH_API } from '../../lib/research';

export const WatchlistStar = ({ symbol, asset, testId = 'research-watchlist-toggle' }) => {
  const [item, setItem] = useState(null), [busy, setBusy] = useState(true), [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setBusy(true); setFailed(false);
    getResearch('/watchlist').then(({ data }) => {
      if (!cancelled) setItem(data.find(row => row.symbol === symbol && row.asset === asset) || null);
    }).catch(() => { if (!cancelled) setFailed(true); }).finally(() => { if (!cancelled) setBusy(false); });
    return () => { cancelled = true; };
  }, [symbol, asset]);
  async function toggle() {
    setBusy(true);
    try {
      if (failed) {
        const { data } = await getResearch('/watchlist');
        setItem(data.find(row => row.symbol === symbol && row.asset === asset) || null); setFailed(false);
      } else if (item) {
        await axios.delete(`${RESEARCH_API}/watchlist/${item.id}`); setItem(null); toast.success('Removed from watchlist');
      } else {
        const { data } = await postResearch('/watchlist', { symbol, asset }); setItem(data); toast.success('Saved to your watchlist');
      }
    } catch (error) { toast.error(apiError(error)); }
    finally { setBusy(false); }
  }
  return <Button variant="ghost" size="icon" data-testid={testId} disabled={busy} onClick={toggle}
    aria-pressed={Boolean(item)} aria-label={failed ? 'Retry watchlist status' : item ? 'Remove from watchlist' : 'Save to watchlist'}
    title={failed ? 'Retry watchlist status' : item ? 'Remove from watchlist' : 'Save to watchlist'}>
    {busy ? <Loader2 size={16} className="animate-spin" /> : <Star size={19} className={item ? 'fill-amber-400 text-amber-400' : 'text-slate-400'} />}
  </Button>;
};